import axios from 'axios'
import { store } from '../../store'
import Constantes from '../../utils/constantes'

export default function setup () {
  axios.interceptors.request.use(
    function (config) {
      // console.log('config antes', config)
      if (store.state.cliente.token !== null && config.url.includes(Constantes.URL_SERVIDOR) && !config.headers.semtoken) {
        // console.log('Vai colocar o header');
        const token = store.state.cliente.token
        if (token) {
          config.headers.Authorization = `${token}`
          // console.log(config.headers.Authorization)
        }
      } else {
        delete config.headers.semtoken;
        delete config.headers.Authorization;
      }
      // console.log('config depois', config)
      return config
    },
    function (err) {
      return Promise.reject(err)
    }
  )
}


// import axios from 'axios'
// import { store } from '../../store'
// import Constantes from '../../utils/constantes'

// export default function setup() {
//   axios.interceptors.request.use(
//     function (config) {
//       console.log(' axios.interceptors.request.use', config.url)
//       if (store.state.cliente.token !== null && config.url.includes(Constantes.URL_SERVIDOR_IS)) {
//         console.log('SERVER IS');
//         return config
//       } else if (store.state.cliente.token !== null && config.url.includes(Constantes.URL_SERVIDOR)) {
//         console.log('Vai colocar o header');
//         return config
//       }
//       const token = store.state.cliente.token
//       if (token) {
//         config.headers.Authorization = `${token}`
//         console.log(config.headers.Authorization)
//       }
//     },
//     function (err) {
//       return Promise.reject(err)
//     }
//   )
// }



// import axios from 'axios'
// import { store } from '../../store'
// import Constantes from '../../utils/constantes'

// export default function setup () {
//   axios.interceptors.request.use(
//     function (config) {
//       console.log(' axios.interceptors.request.use', config.url)
//       if (store.state.cliente.token !== null && (config.url.includes(Constantes.URL_SERVIDOR) || config.url.includes(Constantes.URL_SERVIDOR_IS))) {
//         console.log('Vai colocar o header');

//         const token = store.state.cliente.token
//         if (token) {
//           config.headers.Authorization = `${token}`
//           console.log(config.headers.Authorization)
//         }
//       }
//       return config
//     },
//     function (err) {
//       return Promise.reject(err)
//     }
//   )
// }